import { render, staticRenderFns } from "./Crisis_addmajor_event.vue?vue&type=template&id=42d6f5b8"
import script from "./Crisis_addmajor_event.vue?vue&type=script&lang=js"
export * from "./Crisis_addmajor_event.vue?vue&type=script&lang=js"
import style0 from "./Crisis_addmajor_event.vue?vue&type=style&index=0&id=42d6f5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports